module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/1c1422ff460ae119ae230d5e238ecc7c.png";